export default __webpack_public_path__ + "static/media/bookShop.d22d8aee.PNG";